<template>
  <v-app v-if="layoutComponent">
    <Component :is="layoutComponent">
      <slot />
    </Component>
  </v-app>
  <error-messages-viewer />
  <offline-request-error />
  <lock-resource-error />
  <error-snackbar />
  <common-confirmation-dialog />
  <snackbar />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import CommonConfirmationDialog from '@/core/components/modals/CommonConfirmationDialog.vue';
import Account from '@/core/layouts/Account.vue';
import Auth from '@/core/layouts/Auth.vue';
import Default from '@/core/layouts/Default.vue';
import Empty from '@/core/layouts/Empty.vue';
import Snackbar from '@/core/layouts/components/Snackbar.vue';
import ErrorSnackbar from '@/parts/errors/components/ErrorSnackbar.vue';
import ErrorMessagesViewer from '@/parts/errors/components/MessageViewer.vue';
import OfflineRequestError from '@/parts/errors/components/OfflineRequestError.vue';
import LockResourceError from '@/parts/errors/components/ReloadPageAlert.vue';

const $route = useRoute();

const Layouts = {
  Default,
  Auth,
  Empty,
  Account,
};

const layoutComponent = computed(() => {
  if (!$route.name) {
    return '';
  }
  const layoutName = $route.meta.layout || 'Default';

  return Layouts[layoutName];
});
</script>

<style scoped></style>
